/**
 * Save Data Actor
 *
 * XState actor that saves import data to the backend.
 * This is a simplified version that only saves - reloading is handled
 * by a separate actor in the OPERATING flow.
 *
 * Flow:
 * 1. Convert ImportData to API format (toRowsJSON)
 * 2. Save to backend via updateImportPreview
 */
import { fromPromise } from 'xstate'
import { updateImportPreview } from 'services/importengine'
import { ImportData, ImportDataRowsFormat } from '../../importer-types'

export interface SaveDataInput {
  importNumber: number
  data: ImportData
}

export type SaveDataOutput = void

/**
 * Convert ImportData (UI format) to ImportDataRowsFormat (API format)
 */
function toRowsJSON(data: ImportData): ImportDataRowsFormat {
  if (!data.rows.length) {
    return {
      headers: [],
      rows: {
        columns: [],
        rows: [],
      },
    }
  }
  const columns = Object.keys(data.rows[0])
  const rows = data.rows.map((obj) => columns.map((key) => obj[key]))
  return {
    headers: data.headers,
    rows: {
      columns,
      rows,
    },
  }
}

export const saveDataActor = fromPromise<SaveDataOutput, SaveDataInput>(
  async ({ input }) => {
    const jsonData = toRowsJSON(input.data)
    await updateImportPreview(input.importNumber, {
      import_data: { data: jsonData },
    })
  }
)
